import { Col, Row } from '@policygenius/mortar';
import { FormRenderProps } from 'react-final-form';

import MaskedTextField from 'components/formInputs/MaskedTextField';
import { phoneMask } from 'components/formInputs/MaskedTextField/masks';
import SelectField from 'components/formInputs/SelectField';
import TextField from 'components/formInputs/TextField';
import FormWrapper from 'components/FormWrapper';
import { InitialValues } from 'forms/types';

import { LABELS, PHONE_TYPES } from './constants';
import { ApplicationFormValues } from './types';

export type ApplicationFormProps = FormRenderProps<
  ApplicationFormValues,
  InitialValues<ApplicationFormValues>
>;

const ApplicationForm: React.FC<ApplicationFormProps> = ({ handleSubmit, invalid, submitting }) => (
  <FormWrapper
    handleSubmit={handleSubmit}
    invalid={invalid}
    submitting={submitting}
    submitText="Get My Rates"
  >
    <Row nested>
      <Col span={{ medium: 12, large: 6 }}>
        <TextField name="firstName" label={LABELS.firstName} />
      </Col>
      <Col span={{ medium: 12, large: 6 }}>
        <TextField name="lastName" label={LABELS.lastName} />
      </Col>
    </Row>
    <TextField name="email" label={LABELS.email} />
    <SelectField name="phoneType" label={LABELS.phoneType} options={PHONE_TYPES} />
    <MaskedTextField name="phoneNumber" label={LABELS.phoneNumber} maskOptions={phoneMask} />
  </FormWrapper>
);

export default ApplicationForm;
